var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isProjectReady)?_c('div',{staticClass:"document"},_vm._l((_vm.pages),function(page,index){return _c('DocumentPrintPage',{key:page.id,attrs:{"fields":_vm.getFieldsByPage(index),"project":_vm.project,"image":page.path}})}),1):_c('div',[_vm._v("Keine Daten vorhanden!")])
}
var staticRenderFns = []

export { render, staticRenderFns }